import useQuery from "routing/useQuery";
export const HEALTH_QUERY_PARAM = "health";
export const HEALTH_ON_VALUE = "on";
const useHealthModuleVisible = () => useQuery()[HEALTH_QUERY_PARAM] === HEALTH_ON_VALUE;
export default useHealthModuleVisible;
